<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item logo" @click="$router.push('/').catch(() => {})">
        <img :src="this.$store.state.config.logo">
      </a>

      <a :class="[navbarActive ? 'is-active' : '', 'navbar-burger burger']" role="button" aria-label="menu" aria-expanded="false" @click="navbarActive = !navbarActive">
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </a>
    </div>

    <div :class="[navbarActive ? 'is-active' : '', 'navbar-menu']">
      <div class="navbar-end">
        <a v-if="is('admin')" class="navbar-item files" @click="$router.push('/').catch(() => {})">
          {{ lang('Files') }}
        </a>
        <a v-if="is('admin')" class="navbar-item users" @click="$router.push('/users').catch(() => {})">
          {{ lang('Users') }}
        </a>
        <a v-if="is('admin')" class="navbar-item cauhinh" @click="$router.push('/cauhinh').catch(() => {})">
          {{ lang('Cấu hình Site') }}
        </a>
        <a v-if="is('admin')" class="navbar-item logs" @click="$router.push('/logs').catch(() => {})">
          {{ lang('System log') }}
        </a>
        <a v-if="is('admin')" class="navbar-item tainguyen" @click="$router.push('/tainguyen').catch(() => {})">
          {{ lang('Tài nguyên máy chủ') }}
        </a>
        <a v-if="is('admin')" class="navbar-item capnhat" @click="$router.push('/capnhat').catch(() => {})">
          {{ lang('Tìm bản mới') }}
          <span v-if="$store.state.capNhat.soMoi" class="tag is-info is-rounded" style="margin-left: 6px">{{ $store.state.capNhat.soMoi }}</span>
        </a>
        <a v-if="is('guest')" class="navbar-item login" @click="login">
          {{ lang('Login') }}
        </a>
        <a v-if="!is('guest') && !is('admin')" class="navbar-item profile" @click="profile">
          {{ this.$store.state.user.name }}
        </a>
        <a v-if="!is('guest')" class="navbar-item logout" @click="logout">
          {{ lang('Logout') }}
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import Profile from './Profile'

export default {
  name: 'Menu',
  data() {
    return {
      navbarActive: false,
    }
  },
  mounted() {
    if (this.$store.state.user.firstlogin) {
      this.profile()
    }
    this.taiCapNhat()
  },
  methods: {
    logout() {
      this.forceLogout()
    },
    login() {
      this.$router.push('/login').catch(() => {})
    },
    profile() {
      this.$modal.open({
        parent: this,
        hasModalCard: true,
        component: Profile,
      })
    },
  }
}
</script>

<style scoped>
.navbar {
  z-index: 10;
}
@media all and (max-width: 1088px) {
  .logo {
    padding: 0;
  }
  .logo img {
    max-height: 3rem;
  }
}
@media all and (min-width: 1088px) {
  .navbar {
    padding: 1rem 0;
  }
  .logo {
    padding: 0 0 0 12px;
  }
  .logo img {
    max-height: 2.5rem;
  }
}
</style>
